{
  "level": "jct01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:jct01",
    "objects": "AREAS.E3:jct01.e3",
    "mesh": "TREES.E3:jct01.e3"
  },
  "spawn_point": {
    "position": [
      -2537.4295188802084,
      -3927.312354166667,
      1055.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -2537.4295188802084,
      -3827.312354166667,
      1055.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3025.681396484375,
      -4221.736328125,
      1031.0
    ],
    "bbox_max": [
      -1947.011474609375,
      -3134.806640625,
      1534.9000244140625
    ],
    "vertex_count": 375,
    "vertices": [
      [
        -2323.703125,
        -3387.331787109375,
        1264.5025634765625
      ],
      [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      [
        -2345.931884765625,
        -3369.565673828125,
        1273.7713623046875
      ],
      [
        -2323.703125,
        -3387.331787109375,
        1264.5025634765625
      ],
      [
        -2137.895263671875,
        -3234.538818359375,
        1428.4024658203125
      ],
      [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      [
        -2137.895263671875,
        -3234.538818359375,
        1428.4024658203125
      ],
      [
        -2084.453369140625,
        -3195.6806640625,
        1471.4671630859375
      ],
      [
        -2041.1224365234375,
        -3209.934814453125,
        1425.5068359375
      ],
      [
        -2041.1224365234375,
        -3209.934814453125,
        1425.5068359375
      ],
      [
        -2084.453369140625,
        -3195.6806640625,
        1471.4671630859375
      ],
      [
        -2018.78173828125,
        -3134.806640625,
        1534.9000244140625
      ],
      [
        -1947.011474609375,
        -3160.40380859375,
        1455.5673828125
      ],
      [
        -2022.432373046875,
        -3203.653564453125,
        1425.7393798828125
      ],
      [
        -2345.931884765625,
        -3369.565673828125,
        1273.7713623046875
      ],
      [
        -2701.116455078125,
        -3311.600830078125,
        1240.890869140625
      ],
      [
        -2762.749267578125,
        -3310.467041015625,
        1228.0357666015625
      ],
      [
        -2701.116455078125,
        -3311.600830078125,
        1240.890869140625
      ],
      [
        -2795.463134765625,
        -3394.051025390625,
        1052.5999755859375
      ],
      [
        -2762.749267578125,
        -3310.466796875,
        1228.035888671875
      ],
      [
        -2848.79736328125,
        -3363.318115234375,
        1119.56982421875
      ],
      [
        -2800.916259765625,
        -3324.55126953125,
        1208.229248046875
      ],
      [
        -2921.400146484375,
        -3392.0107421875,
        1052.5999755859375
      ],
      [
        -2848.796875,
        -3363.318359375,
        1119.5692138671875
      ],
      [
        -2675.971435546875,
        -3388.3564453125,
        1069.7086181640625
      ],
      [
        -2655.969970703125,
        -3389.39111328125,
        1068.1156005859375
      ],
      [
        -2655.413818359375,
        -3384.099365234375,
        1080.0
      ],
      [
        -2675.489990234375,
        -3383.774169921875,
        1080.0
      ],
      [
        -2655.413818359375,
        -3384.099365234375,
        1080.0
      ],
      [
        -2655.969970703125,
        -3389.39111328125,
        1068.1156005859375
      ],
      [
        -2706.755615234375,
        -3545.0615234375,
        1052.5999755859375
      ],
      [
        -2723.912109375,
        -3540.279296875,
        1052.5999755859375
      ],
      [
        -2622.0,
        -3568.687255859375,
        1052.5999755859375
      ],
      [
        -2617.290771484375,
        -3570.0,
        1052.5999755859375
      ],
      [
        -2737.04052734375,
        -3536.619384765625,
        1052.5999755859375
      ],
      [
        -2755.54150390625,
        -3531.462890625,
        1052.5999755859375
      ],
      [
        -2617.2919921875,
        -3570.0,
        1052.5999755859375
      ],
      [
        -2541.44140625,
        -3570.0,
        1052.5999755859375
      ],
      [
        -2576.199462890625,
        -3581.45458984375,
        1052.5999755859375
      ],
      [
        -2576.198974609375,
        -3581.45458984375,
        1052.5999755859375
      ],
      [
        -2625.789794921875,
        -3567.631103515625,
        1052.5999755859375
      ],
      [
        -2625.789794921875,
        -3567.631103515625,
        1052.5999755859375
      ],
      [
        -2811.588623046875,
        -3515.83935546875,
        1052.5999755859375
      ],
      [
        -3025.681396484375,
        -3391.85888671875,
        1104.1143798828125
      ],
      [
        -2885.978271484375,
        -3355.941162109375,
        1164.0865478515625
      ],
      [
        -2885.978515625,
        -3355.94091796875,
        1164.086669921875
      ],
      [
        -2520.0,
        -3572.558349609375,
        1052.5999755859375
      ],
      [
        -2556.9482421875,
        -3586.821044921875,
        1052.5999755859375
      ],
      [
        -2556.947509765625,
        -3586.82080078125,
        1052.5999755859375
      ],
      [
        -2036.2060546875,
        -3211.552001953125,
        1420.2921142578125
      ],
      [
        -2036.2060546875,
        -3211.552001953125,
        1420.2921142578125
      ],
      [
        -2545.543701171875,
        -3590.0,
        1052.5999755859375
      ],
      [
        -2349.25244140625,
        -3644.7158203125,
        1052.5999755859375
      ],
      [
        -2294.21240234375,
        -3660.058349609375,
        1052.5999755859375
      ],
      [
        -2349.25244140625,
        -3644.7158203125,
        1052.5999755859375
      ],
      [
        -2428.80322265625,
        -3622.541015625,
        1052.5999755859375
      ],
      [
        -2428.80322265625,
        -3622.541015625,
        1052.5999755859375
      ],
      [
        -2800.916259765625,
        -3324.55126953125,
        1208.229248046875
      ],
      [
        -2963.16357421875,
        -3340.626708984375,
        1256.500244140625
      ],
      [
        -3008.044677734375,
        -3348.62255859375,
        1249.8856201171875
      ],
      [
        -2963.163330078125,
        -3340.626708984375,
        1256.5001220703125
      ],
      [
        -2759.193603515625,
        -3612.825927734375,
        1052.5999755859375
      ],
      [
        -2779.099853515625,
        -3612.503173828125,
        1052.5999755859375
      ],
      [
        -2522.1767578125,
        -3616.666015625,
        1052.5999755859375
      ],
      [
        -2502.28173828125,
        -3616.988037109375,
        1052.5999755859375
      ],
      [
        -2646.214111328125,
        -3614.65625,
        1052.5999755859375
      ],
      [
        -2445.4189453125,
        -3617.909423828125,
        1052.5999755859375
      ],
      [
        -2646.214111328125,
        -3614.656494140625,
        1052.5999755859375
      ],
      [
        -2824.290771484375,
        -3611.771240234375,
        1052.5999755859375
      ],
      [
        -3016.616455078125,
        -3239.552001953125,
        1476.240234375
      ],
      [
        -2318.345458984375,
        -3383.212646484375,
        1268.9989013671875
      ],
      [
        -2646.895263671875,
        -3616.224365234375,
        1052.5999755859375
      ],
      [
        -2642.328125,
        -3614.71923828125,
        1052.5999755859375
      ],
      [
        -2646.895263671875,
        -3616.224609375,
        1052.5999755859375
      ],
      [
        -2833.001220703125,
        -3677.55712890625,
        1052.5999755859375
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      [
        -2394.315673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1049.123779296875
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      [
        -2508.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1049.123779296875
      ],
      [
        -2508.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      [
        -2500.0,
        -4045.300048828125,
        1032.0
      ],
      [
        -2518.815673828125,
        -4045.300048828125,
        1032.0
      ],
      [
        -2410.0,
        -4045.300048828125,
        1032.0
      ],
      [
        -2429.0,
        -4045.300048828125,
        1032.0
      ],
      [
        -2394.315673828125,
        -4044.300048828125,
        1032.0
      ],
      [
        -2394.315673828125,
        -4045.300048828125,
        1032.0
      ],
      [
        -2410.0,
        -4045.300048828125,
        1032.0
      ],
      [
        -2394.315673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      [
        -2394.315673828125,
        -4045.300048828125,
        1049.123779296875
      ],
      [
        -2394.315673828125,
        -4045.300048828125,
        1032.0
      ],
      [
        -2394.315673828125,
        -4044.300048828125,
        1032.0
      ],
      [
        -2518.815673828125,
        -4045.300048828125,
        1032.0
      ],
      [
        -2518.815673828125,
        -4045.300048828125,
        1049.123779296875
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1052.5999755859375
      ],
      [
        -2485.50439453125,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2499.699951171875,
        -4034.28857421875,
        1052.5999755859375
      ],
      [
        -2434.39990234375,
        -4006.00439453125,
        1052.5999755859375
      ],
      [
        -2420.21142578125,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2420.21142578125,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2434.39990234375,
        -4034.28857421875,
        1052.5999755859375
      ],
      [
        -2448.49560546875,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2434.39990234375,
        -4006.00439453125,
        1052.5999755859375
      ],
      [
        -2434.39990234375,
        -4034.28857421875,
        1052.5999755859375
      ],
      [
        -2448.49560546875,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2499.699951171875,
        -4006.00439453125,
        1052.5999755859375
      ],
      [
        -2485.50439453125,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2513.78857421875,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2499.699951171875,
        -4006.00439453125,
        1052.5999755859375
      ],
      [
        -2499.699951171875,
        -4034.28857421875,
        1052.5999755859375
      ],
      [
        -2513.78857421875,
        -4020.146484375,
        1052.5999755859375
      ],
      [
        -2421.453369140625,
        -3981.744384765625,
        1032.0
      ],
      [
        -2421.453369140625,
        -3981.744384765625,
        1031.0
      ],
      [
        -2467.45361328125,
        -3981.7421875,
        1032.0
      ],
      [
        -2467.45361328125,
        -3981.7421875,
        1031.0
      ],
      [
        -2469.453857421875,
        -4033.742431640625,
        1032.0
      ],
      [
        -2469.453857421875,
        -4033.742431640625,
        1031.0
      ],
      [
        -2514.800048828125,
        -4033.741943359375,
        1032.0
      ],
      [
        -2514.800048828125,
        -4031.741943359375,
        1032.0
      ],
      [
        -2514.800048828125,
        -4031.741943359375,
        1031.0
      ],
      [
        -2514.800048828125,
        -4033.741943359375,
        1031.0
      ],
      [
        -2550.863525390625,
        -4042.159423828125,
        1102.5850830078125
      ],
      [
        -2576.947509765625,
        -4027.099609375,
        1102.5850830078125
      ],
      [
        -2576.8525390625,
        -4027.154541015625,
        1102.585205078125
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1102.585205078125
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1101.775390625
      ],
      [
        -2508.815673828125,
        -4056.199951171875,
        1100.727783203125
      ],
      [
        -2518.815673828125,
        -4055.364501953125,
        1101.623779296875
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1099.6160888671875
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1097.882080078125
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1099.3458251953125
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1101.7984619140625
      ],
      [
        -2544.737548828125,
        -4041.3603515625,
        1101.7984619140625
      ],
      [
        -2530.148681640625,
        -4054.119140625,
        1101.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1101.623779296875
      ],
      [
        -2532.423828125,
        -4048.4697265625,
        1101.623779296875
      ],
      [
        -2530.148681640625,
        -4049.783203125,
        1101.623779296875
      ],
      [
        -2532.423828125,
        -4048.4697265625,
        1101.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1101.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1102.5850830078125
      ],
      [
        -2532.423828125,
        -4048.4697265625,
        1101.79833984375
      ],
      [
        -2535.894287109375,
        -4050.221435546875,
        1102.479736328125
      ],
      [
        -2535.88818359375,
        -4050.8056640625,
        1102.2750244140625
      ],
      [
        -2535.88818359375,
        -4050.8056640625,
        1102.5850830078125
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.41748046875
      ],
      [
        -2556.205322265625,
        -3981.623291015625,
        1092.160400390625
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1101.7984619140625
      ],
      [
        -2537.567626953125,
        -4018.94189453125,
        1096.9793701171875
      ],
      [
        -2549.067626953125,
        -4038.8603515625,
        1101.7984619140625
      ],
      [
        -2537.567626953125,
        -4018.94189453125,
        1096.9793701171875
      ],
      [
        -2530.567626953125,
        -4006.8173828125,
        1094.0460205078125
      ],
      [
        -2536.020263671875,
        -4026.26171875,
        1098.1455078125
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2536.020263671875,
        -4026.26171875,
        1098.1455078125
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2544.737548828125,
        -4041.3603515625,
        1101.7984619140625
      ],
      [
        -2540.882568359375,
        -4034.68359375,
        1100.18310546875
      ],
      [
        -2544.737548828125,
        -4041.3603515625,
        1101.7984619140625
      ],
      [
        -2540.882568359375,
        -4034.68359375,
        1100.18310546875
      ],
      [
        -2531.887939453125,
        -4047.817138671875,
        1101.623779296875
      ],
      [
        -2530.148681640625,
        -4048.8212890625,
        1101.623779296875
      ],
      [
        -2531.887939453125,
        -4047.817138671875,
        1101.623779296875
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2537.567626953125,
        -4018.94189453125,
        1096.9793701171875
      ],
      [
        -2574.875,
        -4023.96044921875,
        1101.7984619140625
      ],
      [
        -2563.375,
        -4004.0419921875,
        1096.9793701171875
      ],
      [
        -2556.375,
        -3991.91748046875,
        1094.046142578125
      ],
      [
        -2563.375,
        -4004.0419921875,
        1096.9793701171875
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2563.375,
        -4004.0419921875,
        1096.9793701171875
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1098.47119140625
      ],
      [
        -2530.148681640625,
        -4036.266357421875,
        1099.345703125
      ],
      [
        -2526.588623046875,
        -4056.1748046875,
        1101.623779296875
      ],
      [
        -2518.815673828125,
        -4055.364501953125,
        1101.623779296875
      ],
      [
        -2526.588623046875,
        -4056.1748046875,
        1101.623779296875
      ],
      [
        -2518.815673828125,
        -4056.199951171875,
        1101.775390625
      ],
      [
        -2526.588623046875,
        -4056.1748046875,
        1102.5850830078125
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1097.0074462890625
      ],
      [
        -2521.800048828125,
        -4036.266357421875,
        1098.47119140625
      ],
      [
        -2530.148681640625,
        -4028.199951171875,
        1097.882080078125
      ],
      [
        -2521.800048828125,
        -4028.199951171875,
        1097.0074462890625
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1098.568603515625
      ],
      [
        -2518.815673828125,
        -4044.300048828125,
        1099.6160888671875
      ],
      [
        -2508.815673828125,
        -4044.300048828125,
        1098.568603515625
      ],
      [
        -2508.815673828125,
        -4056.199951171875,
        1100.727783203125
      ],
      [
        -2544.672119140625,
        -4079.9130859375,
        1096.623779296875
      ],
      [
        -2553.33251953125,
        -4074.9130859375,
        1098.457275390625
      ],
      [
        -2550.83251953125,
        -4070.5830078125,
        1098.4569091796875
      ],
      [
        -2551.265625,
        -4070.3330078125,
        1098.123779296875
      ],
      [
        -2550.83251953125,
        -4070.5830078125,
        1098.45703125
      ],
      [
        -2549.31689453125,
        -4071.4580078125,
        1099.623779296875
      ],
      [
        -2551.817138671875,
        -4075.787841796875,
        1099.623779296875
      ],
      [
        -2549.96630859375,
        -4071.0830078125,
        1099.123779296875
      ],
      [
        -2549.31689453125,
        -4071.4580078125,
        1099.623779296875
      ],
      [
        -2548.01806640625,
        -4072.2080078125,
        1100.623779296875
      ],
      [
        -2550.51806640625,
        -4076.5380859375,
        1100.623779296875
      ],
      [
        -2548.66748046875,
        -4071.8330078125,
        1100.123779296875
      ],
      [
        -2548.01806640625,
        -4072.2080078125,
        1100.623779296875
      ],
      [
        -2543.80615234375,
        -4080.4130859375,
        1101.1239013671875
      ],
      [
        -2541.2080078125,
        -4081.9130859375,
        1096.623779296875
      ],
      [
        -2541.2080078125,
        -4081.9130859375,
        1099.123779296875
      ],
      [
        -2528.7080078125,
        -4060.262451171875,
        1099.1236572265625
      ],
      [
        -2528.7080078125,
        -4060.262451171875,
        1096.623779296875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1101.1239013671875
      ],
      [
        -2543.156494140625,
        -4080.7880859375,
        1100.623779296875
      ],
      [
        -2540.656494140625,
        -4076.4580078125,
        1100.623779296875
      ],
      [
        -2540.656494140625,
        -4076.4580078125,
        1100.623779296875
      ],
      [
        -2540.007080078125,
        -4076.8330078125,
        1100.123779296875
      ],
      [
        -2528.7080078125,
        -4060.262451171875,
        1101.623779296875
      ],
      [
        -2541.2080078125,
        -4081.9130859375,
        1101.623779296875
      ],
      [
        -2606.657958984375,
        -4065.269775390625,
        1112.623779296875
      ],
      [
        -2608.39208984375,
        -4069.6826171875,
        1113.606201171875
      ],
      [
        -2622.54541015625,
        -4105.69677734375,
        1121.623779296875
      ],
      [
        -2608.39208984375,
        -4069.6826171875,
        1113.606201171875
      ],
      [
        -2705.027099609375,
        -4221.736328125,
        1151.3204345703125
      ],
      [
        -2622.54541015625,
        -4105.69677734375,
        1121.623779296875
      ],
      [
        -2616.16259765625,
        -4037.73828125,
        1108.623779296875
      ],
      [
        -2615.05224609375,
        -4035.81494140625,
        1108.158447265625
      ],
      [
        -2619.05224609375,
        -4042.7431640625,
        1109.834716796875
      ],
      [
        -2614.05224609375,
        -4034.0830078125,
        1107.739501953125
      ],
      [
        -2614.05224609375,
        -4034.0830078125,
        1107.739501953125
      ],
      [
        -2622.712646484375,
        -4029.0830078125,
        1107.739501953125
      ],
      [
        -2619.331298828125,
        -4023.23193359375,
        1106.323486328125
      ],
      [
        -2618.331298828125,
        -4021.5,
        1105.9044189453125
      ],
      [
        -2622.712646484375,
        -4029.0830078125,
        1107.739501953125
      ],
      [
        -2617.712646484375,
        -4020.422607421875,
        1105.644287109375
      ],
      [
        -2598.03564453125,
        -4043.330078125,
        1107.739501953125
      ],
      [
        -2603.659912109375,
        -4040.0830078125,
        1107.739501953125
      ],
      [
        -2601.834228515625,
        -4041.13720703125,
        1101.623779296875
      ],
      [
        -2587.554443359375,
        -4037.83447265625,
        1105.6441650390625
      ],
      [
        -2579.181640625,
        -4025.809814453125,
        1102.5850830078125
      ],
      [
        -2606.657958984375,
        -4065.269775390625,
        1112.623779296875
      ],
      [
        -2593.289306640625,
        -4046.0703125,
        1107.739501953125
      ],
      [
        -2593.289306640625,
        -4046.0703125,
        1107.739501953125
      ],
      [
        -2561.257568359375,
        -4070.33740234375,
        1108.7869873046875
      ],
      [
        -2550.59228515625,
        -4047.627685546875,
        1103.5489501953125
      ],
      [
        -2567.65673828125,
        -4083.96337890625,
        1111.929931640625
      ],
      [
        -2557.368408203125,
        -4089.9033203125,
        1111.929931640625
      ],
      [
        -2546.03369140625,
        -4100.27099609375,
        1112.623779296875
      ],
      [
        -2559.024169921875,
        -4092.771240234375,
        1112.623779296875
      ],
      [
        -2557.368408203125,
        -4089.9033203125,
        1111.929931640625
      ],
      [
        -2559.024169921875,
        -4092.771240234375,
        1112.623779296875
      ],
      [
        -2543.80615234375,
        -4080.4130859375,
        1108.7869873046875
      ],
      [
        -2532.5478515625,
        -4086.9130859375,
        1108.787109375
      ],
      [
        -2549.868408203125,
        -4076.9130859375,
        1108.787109375
      ],
      [
        -2561.257568359375,
        -4070.33740234375,
        1108.7869873046875
      ],
      [
        -2552.368408203125,
        -4081.2431640625,
        1109.834716796875
      ],
      [
        -2549.868408203125,
        -4076.9130859375,
        1108.787109375
      ],
      [
        -2546.30615234375,
        -4084.7431640625,
        1109.834716796875
      ],
      [
        -2543.80615234375,
        -4080.4130859375,
        1108.7869873046875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1103.5489501953125
      ],
      [
        -2520.0478515625,
        -4065.262451171875,
        1103.5489501953125
      ],
      [
        -2537.368408203125,
        -4055.262451171875,
        1103.5489501953125
      ],
      [
        -2550.59228515625,
        -4047.627685546875,
        1103.5489501953125
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1103.5489501953125
      ],
      [
        -2529.80615234375,
        -4056.164306640625,
        1102.92041015625
      ],
      [
        -2529.80615234375,
        -4056.164306640625,
        1102.9202880859375
      ],
      [
        -2537.368408203125,
        -4055.262451171875,
        1103.5489501953125
      ],
      [
        -2535.868408203125,
        -4052.664306640625,
        1102.9202880859375
      ],
      [
        -2535.868408203125,
        -4052.664306640625,
        1102.9202880859375
      ],
      [
        -2535.868408203125,
        -4052.664306640625,
        1102.9202880859375
      ],
      [
        -2550.66748046875,
        -4075.296875,
        1108.5775146484375
      ],
      [
        -2551.600341796875,
        -4075.9130859375,
        1108.7869873046875
      ],
      [
        -2549.80126953125,
        -4075.796875,
        1108.5775146484375
      ],
      [
        -2549.868408203125,
        -4076.9130859375,
        1108.787109375
      ],
      [
        -2549.80126953125,
        -4075.796875,
        1108.5775146484375
      ],
      [
        -2550.66748046875,
        -4075.296875,
        1108.57763671875
      ],
      [
        -2532.5478515625,
        -4086.9130859375,
        1108.787109375
      ],
      [
        -2531.181884765625,
        -4086.546875,
        1108.5775146484375
      ],
      [
        -2531.181884765625,
        -4086.546875,
        1108.5775146484375
      ],
      [
        -2529.681884765625,
        -4083.948974609375,
        1107.948974609375
      ],
      [
        -2524.681884765625,
        -4075.28857421875,
        1105.853759765625
      ],
      [
        -2526.181884765625,
        -4077.88671875,
        1106.4822998046875
      ],
      [
        -2519.681884765625,
        -4066.62841796875,
        1103.758544921875
      ],
      [
        -2521.181884765625,
        -4069.2265625,
        1104.3870849609375
      ],
      [
        -2528.913818359375,
        -4078.61865234375,
        1106.9013671875
      ],
      [
        -2530.413818359375,
        -4081.216796875,
        1107.5299072265625
      ],
      [
        -2523.913818359375,
        -4069.95849609375,
        1104.8060302734375
      ],
      [
        -2525.413818359375,
        -4072.556640625,
        1105.4346923828125
      ],
      [
        -2527.5478515625,
        -4078.252685546875,
        1106.6917724609375
      ],
      [
        -2528.913818359375,
        -4078.61865234375,
        1106.9013671875
      ],
      [
        -2527.5478515625,
        -4078.252685546875,
        1106.6917724609375
      ],
      [
        -2526.181884765625,
        -4077.88671875,
        1106.4822998046875
      ],
      [
        -2525.0478515625,
        -4073.922607421875,
        1105.6441650390625
      ],
      [
        -2524.681884765625,
        -4075.28857421875,
        1105.853759765625
      ],
      [
        -2525.0478515625,
        -4073.922607421875,
        1105.6441650390625
      ],
      [
        -2525.413818359375,
        -4072.556640625,
        1105.4346923828125
      ],
      [
        -2522.5478515625,
        -4069.592529296875,
        1104.5965576171875
      ],
      [
        -2523.913818359375,
        -4069.95849609375,
        1104.8060302734375
      ],
      [
        -2522.5478515625,
        -4069.592529296875,
        1104.5965576171875
      ],
      [
        -2521.181884765625,
        -4069.2265625,
        1104.3870849609375
      ],
      [
        -2520.0478515625,
        -4065.262451171875,
        1103.5489501953125
      ],
      [
        -2519.681884765625,
        -4066.62841796875,
        1103.758544921875
      ],
      [
        -2537.368408203125,
        -4055.262451171875,
        1103.5489501953125
      ],
      [
        -2538.30126953125,
        -4055.87841796875,
        1103.758544921875
      ],
      [
        -2539.100341796875,
        -4054.262451171875,
        1103.5489501953125
      ],
      [
        -2539.16748046875,
        -4055.37841796875,
        1103.758544921875
      ],
      [
        -2539.16748046875,
        -4055.37841796875,
        1103.758544921875
      ],
      [
        -2538.30126953125,
        -4055.87841796875,
        1103.758544921875
      ],
      [
        -2531.30615234375,
        -4058.762451171875,
        1103.5489501953125
      ],
      [
        -2531.373046875,
        -4059.87841796875,
        1103.758544921875
      ],
      [
        -2529.57421875,
        -4059.762451171875,
        1103.5489501953125
      ],
      [
        -2530.507080078125,
        -4060.37841796875,
        1103.758544921875
      ],
      [
        -2531.373046875,
        -4059.87841796875,
        1103.758544921875
      ],
      [
        -2530.507080078125,
        -4060.37841796875,
        1103.758544921875
      ],
      [
        -2527.950439453125,
        -4036.266357421875,
        1115.6239013671875
      ],
      [
        -2527.950439453125,
        -4036.266357421875,
        1099.115478515625
      ],
      [
        -2523.4912109375,
        -4044.300048828125,
        1101.623779296875
      ],
      [
        -2523.4912109375,
        -4044.300048828125,
        1112.623779296875
      ],
      [
        -2518.815673828125,
        -4052.72216796875,
        1112.623779296875
      ],
      [
        -2516.885009765625,
        -4056.199951171875,
        1112.623779296875
      ],
      [
        -2518.815673828125,
        -4052.72216796875,
        1112.623779296875
      ],
      [
        -2523.4912109375,
        -4044.300048828125,
        1112.623779296875
      ],
      [
        -2516.885009765625,
        -4056.199951171875,
        1112.623779296875
      ],
      [
        -2516.885009765625,
        -4056.199951171875,
        1101.5731201171875
      ],
      [
        -2523.4912109375,
        -4044.300048828125,
        1101.623779296875
      ],
      [
        -2518.815673828125,
        -4052.72265625,
        1101.623779296875
      ],
      [
        -2518.815673828125,
        -4052.72265625,
        1101.623779296875
      ],
      [
        -2518.815673828125,
        -4052.72265625,
        1101.1444091796875
      ],
      [
        -2532.428466796875,
        -4028.199951171875,
        1110.0
      ],
      [
        -2532.428466796875,
        -4028.199951171875,
        1108.0
      ],
      [
        -2532.428466796875,
        -4028.199951171875,
        1104.6239013671875
      ],
      [
        -2532.428466796875,
        -4028.199951171875,
        1115.6239013671875
      ],
      [
        -2530.148681640625,
        -4032.306640625,
        1115.6239013671875
      ],
      [
        -2532.428466796875,
        -4028.199951171875,
        1115.6239013671875
      ],
      [
        -2527.950439453125,
        -4036.266357421875,
        1115.6239013671875
      ],
      [
        -2530.148681640625,
        -4032.306640625,
        1115.6239013671875
      ],
      [
        -2530.148681640625,
        -4032.306640625,
        1104.6239013671875
      ],
      [
        -2530.148681640625,
        -4032.306640625,
        1098.6273193359375
      ],
      [
        -2532.428466796875,
        -4028.199951171875,
        1104.6239013671875
      ],
      [
        -2530.148681640625,
        -4032.306640625,
        1104.6239013671875
      ],
      [
        -2549.0673828125,
        -4038.860595703125,
        1101.7984619140625
      ],
      [
        -2549.0673828125,
        -4038.860595703125,
        1142.623779296875
      ],
      [
        -2519.03564453125,
        -4056.19921875,
        1112.623779296875
      ],
      [
        -2526.588623046875,
        -4056.1748046875,
        1112.623779296875
      ],
      [
        -2526.588623046875,
        -4056.1748046875,
        1102.5850830078125
      ],
      [
        -2519.03564453125,
        -4056.19921875,
        1101.79833984375
      ],
      [
        -2532.423828125,
        -4048.469482421875,
        1112.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      [
        -2526.588623046875,
        -4056.1748046875,
        1112.623779296875
      ],
      [
        -2519.03564453125,
        -4056.19921875,
        1112.623779296875
      ],
      [
        -2535.887939453125,
        -4050.805419921875,
        1113.275146484375
      ],
      [
        -2535.93408203125,
        -4046.44287109375,
        1114.8037109375
      ],
      [
        -2535.93408203125,
        -4046.44287109375,
        1112.623779296875
      ],
      [
        -2535.887939453125,
        -4050.805419921875,
        1112.623779296875
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      [
        -2532.423828125,
        -4048.469482421875,
        1112.623779296875
      ],
      [
        -2532.423828125,
        -4048.4697265625,
        1101.79833984375
      ],
      [
        -2534.839111328125,
        -4051.410888671875,
        1102.5850830078125
      ],
      [
        -2535.93408203125,
        -4046.44287109375,
        1103.8037109375
      ],
      [
        -2535.88818359375,
        -4050.8056640625,
        1102.5850830078125
      ],
      [
        -2535.958740234375,
        -4044.102294921875,
        1112.623779296875
      ],
      [
        -2535.93408203125,
        -4046.44287109375,
        1112.623779296875
      ],
      [
        -2517.36865234375,
        -4056.199951171875,
        1101.623779296875
      ],
      [
        -2516.885009765625,
        -4056.199951171875,
        1101.623779296875
      ],
      [
        -2549.0673828125,
        -4038.860595703125,
        1142.623779296875
      ],
      [
        -2574.875,
        -4023.960693359375,
        1101.7984619140625
      ],
      [
        -2574.875,
        -4023.960693359375,
        1142.623779296875
      ],
      [
        -2574.875,
        -4023.960693359375,
        1142.623779296875
      ],
      [
        -2598.035400390625,
        -4043.330322265625,
        1107.739501953125
      ],
      [
        -2535.887939453125,
        -4050.805419921875,
        1112.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.17169524729251862,
        -0.6159459352493286,
        0.7688506841659546
      ],
      "plane_d": -3457.595703125,
      "bbox_min": [
        -3031.9140625,
        -4244.69189453125,
        988.0
      ],
      "bbox_max": [
        -1925.2470703125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32936930656433105,
        -0.8532378077507019,
        0.40435269474983215
      ],
      "plane_d": -2643.852783203125,
      "bbox_min": [
        -3031.9140625,
        -3660.058349609375,
        1026.71435546875
      ],
      "bbox_max": [
        -1925.2470703125,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2802785038948059,
        -0.8504679203033447,
        0.4451383650302887
      ],
      "plane_d": -2792.41162109375,
      "bbox_min": [
        -3031.9140625,
        -3586.821044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1947.011474609375,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4137550890445709,
        -0.7705957889556885,
        0.48475658893585205
      ],
      "plane_d": -4184.68359375,
      "bbox_min": [
        -3031.9140625,
        -3581.45458984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -1947.011474609375,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1947.011474609375,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2137.895263671875,
        -3303.68017578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1947.011474609375,
        -3114.94677734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34101659059524536,
        -0.8381780385971069,
        0.42563509941101074
      ],
      "plane_d": -4166.45947265625,
      "bbox_min": [
        -3031.9140625,
        -3581.45458984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2345.931884765625,
        -3287.13330078125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -2921.400146484375,
        -3397.99365234375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2552.111572265625,
        -3310.466796875,
        1228.035888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18425501883029938,
        -0.9331962466239929,
        0.3085367977619171
      ],
      "plane_d": -2959.1591796875,
      "bbox_min": [
        -2921.400146484375,
        -3392.0107421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2654.7197265625,
        -3310.466796875,
        1228.035888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1306823045015335,
        -0.9546955227851868,
        0.2673548758029938
      ],
      "plane_d": -3137.979736328125,
      "bbox_min": [
        -2921.400146484375,
        -3392.0107421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2792.86328125,
        -3363.318359375,
        1119.5692138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08697842806577682,
        -0.8274903893470764,
        -0.5547022819519043
      ],
      "plane_d": -2443.21435546875,
      "bbox_min": [
        -2675.971435546875,
        -3389.39111328125,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3375.547119140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -2675.489990234375,
        -3389.39111328125,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3375.547119140625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9945216774940491,
        -0.10453074425458908,
        3.076078201047494e-06
      ],
      "plane_d": 2287.120849609375,
      "bbox_min": [
        -2655.969970703125,
        -3389.39111328125,
        1060.994873046875
      ],
      "bbox_max": [
        -2654.7197265625,
        -3377.49658203125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1052.599853515625,
      "bbox_min": [
        -3031.9140625,
        -3581.45458984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2349.54345703125,
        -3324.55126953125,
        1208.229248046875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9945216774940491,
        -0.10453074425458908,
        3.076078201047494e-06
      ],
      "plane_d": 2287.120849609375,
      "bbox_min": [
        -2656.798095703125,
        -3397.2705078125,
        1068.1156005859375
      ],
      "bbox_max": [
        -2655.413818359375,
        -3384.099365234375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1052.599853515625,
      "bbox_min": [
        -2576.199462890625,
        -3586.821044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2022.432373046875,
        -3203.653564453125,
        1425.7393798828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2130.3798828125,
        -3303.68017578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2022.432373046875,
        -3203.653564453125,
        1425.7393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2041.1224365234375,
        -3211.552001953125,
        1420.2921142578125
      ],
      "bbox_max": [
        -2022.432373046875,
        -3203.653564453125,
        1425.7393798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2556.9482421875,
        -3660.058349609375,
        1026.71435546875
      ],
      "bbox_max": [
        -1925.2470703125,
        -3160.40380859375,
        1455.5673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2130.3798828125,
        -3303.68017578125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.2470703125,
        -3160.40380859375,
        1455.5673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2036.2060546875,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1925.2470703125,
        -3160.40380859375,
        1455.5673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1052.599853515625,
      "bbox_min": [
        -2556.9482421875,
        -3660.058349609375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2241.28857421875,
        -3506.75830078125,
        1052.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.009789052419364452,
        -0.60419100522995,
        0.7967793345451355
      ],
      "plane_d": -3048.53662109375,
      "bbox_min": [
        -3025.681396484375,
        -4244.69189453125,
        988.0
      ],
      "bbox_max": [
        -2018.78173828125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014795297756791115,
        -0.9131819009780884,
        0.4072834253311157
      ],
      "plane_d": -3569.4521484375,
      "bbox_min": [
        -3025.681396484375,
        -3617.909423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2445.4189453125,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09112545102834702,
        -0.9304839968681335,
        0.35481786727905273
      ],
      "plane_d": -3767.822265625,
      "bbox_min": [
        -2762.749267578125,
        -3311.600830078125,
        1228.0357666015625
      ],
      "bbox_max": [
        -2701.116455078125,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18425501883029938,
        -0.9331962466239929,
        0.3085367977619171
      ],
      "plane_d": -2959.1591796875,
      "bbox_min": [
        -3025.681396484375,
        -3617.909423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2445.4189453125,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1306823045015335,
        -0.9546955227851868,
        0.2673548758029938
      ],
      "plane_d": -3137.979736328125,
      "bbox_min": [
        -3025.681396484375,
        -3391.85888671875,
        1104.1143798828125
      ],
      "bbox_max": [
        -2885.978271484375,
        -3340.626708984375,
        1256.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -2824.290771484375,
        -3617.909423828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2445.4189453125,
        -3515.83935546875,
        1052.5999755859375
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.3154846429824829,
        -0.6847353577613831,
        0.6569679379463196
      ],
      "plane_d": -2236.382080078125,
      "bbox_min": [
        -3021.666748046875,
        -4244.69189453125,
        988.0
      ],
      "bbox_max": [
        -2018.78173828125,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14996828138828278,
        -0.7595442533493042,
        0.6329313516616821
      ],
      "plane_d": -2905.852783203125,
      "bbox_min": [
        -3016.616455078125,
        -3348.62255859375,
        1249.8856201171875
      ],
      "bbox_max": [
        -2749.9501953125,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18425501883029938,
        -0.9331962466239929,
        0.3085367977619171
      ],
      "plane_d": -2959.1591796875,
      "bbox_min": [
        -3008.044677734375,
        -3348.62255859375,
        1249.8856201171875
      ],
      "bbox_max": [
        -2749.9501953125,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1306823045015335,
        -0.9546955227851868,
        0.2673548758029938
      ],
      "plane_d": -3137.979736328125,
      "bbox_min": [
        -3008.044677734375,
        -3348.62255859375,
        1249.8856201171875
      ],
      "bbox_max": [
        -2963.163330078125,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45930567383766174,
        -0.7651201486587524,
        0.45125314593315125
      ],
      "plane_d": -1759.25537109375,
      "bbox_min": [
        -3016.616455078125,
        -3332.9873046875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2861.24462890625,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -3021.666748046875,
        -4244.69189453125,
        988.0
      ],
      "bbox_max": [
        -2018.78173828125,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45930567383766174,
        -0.7651201486587524,
        0.45125314593315125
      ],
      "plane_d": -1759.25537109375,
      "bbox_min": [
        -3021.666748046875,
        -3677.55712890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2278.3076171875,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34101659059524536,
        -0.8381780385971069,
        0.42563509941101074
      ],
      "plane_d": -4166.45947265625,
      "bbox_min": [
        -2833.001220703125,
        -3677.55712890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2278.3076171875,
        -3287.13330078125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2802785038948059,
        -0.8504679203033447,
        0.4451383650302887
      ],
      "plane_d": -2792.41162109375,
      "bbox_min": [
        -2319.057373046875,
        -3383.212646484375,
        1268.9989013671875
      ],
      "bbox_max": [
        -2278.3076171875,
        -3352.430908203125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -2833.001220703125,
        -3677.55712890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2318.345458984375,
        -3365.8603515625,
        1302.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2802785038948059,
        -0.8504679203033447,
        0.4451383650302887
      ],
      "plane_d": -2792.41162109375,
      "bbox_min": [
        -2323.703125,
        -3387.331787109375,
        1264.5025634765625
      ],
      "bbox_max": [
        -2318.345458984375,
        -3365.8603515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -2838.326416015625,
        -4244.69189453125,
        988.0
      ],
      "bbox_max": [
        -2018.78173828125,
        -3134.806640625,
        1534.9000244140625
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -988.0,
      "bbox_min": [
        -2530.148681640625,
        -4064.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9863842129707336,
        -0.16445770859718323
      ],
      "plane_d": -3745.18701171875,
      "bbox_min": [
        -2530.148681640625,
        -4064.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.98173987865448,
        0.19022861123085022
      ],
      "plane_d": -4087.658203125,
      "bbox_min": [
        -2530.148681640625,
        -4064.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7101868987083435,
        0.7040132284164429
      ],
      "plane_d": -3521.966796875,
      "bbox_min": [
        -2530.148681640625,
        -4064.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4044.300048828125,
      "bbox_min": [
        -2530.148681640625,
        -4064.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4064.300048828125,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1017.5
      ],
      "bbox_max": [
        -2394.315673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1049.123779296875,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1017.5
      ],
      "bbox_max": [
        -2394.315673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2508.815673828125,
      "bbox_min": [
        -2518.815673828125,
        -4056.199951171875,
        1049.123779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2518.815673828125,
        -4056.199951171875,
        1049.123779296875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4045.300048828125,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1017.5
      ],
      "bbox_max": [
        -2394.315673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -2518.815673828125,
        -4045.300048828125,
        1017.5238037109375
      ],
      "bbox_max": [
        -2394.315673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2429.0,
      "bbox_min": [
        -2429.0,
        -4045.300048828125,
        1017.5238037109375
      ],
      "bbox_max": [
        -2429.0,
        -4044.300048828125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2508.815673828125,
      "bbox_min": [
        -2518.815673828125,
        -4045.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2394.315673828125,
      "bbox_min": [
        -2429.0,
        -4045.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2429.0,
      "bbox_min": [
        -2429.0,
        -4045.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2429.0,
        -4044.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2518.815673828125,
      "bbox_min": [
        -2518.815673828125,
        -4045.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2518.815673828125,
        -4044.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1017.5,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1017.5
      ],
      "bbox_max": [
        -2394.315673828125,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6066733598709106,
        0.0,
        0.7949512600898743
      ],
      "plane_d": -2293.999267578125,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1017.5
      ],
      "bbox_max": [
        -2394.315673828125,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -2429.0,
        -4064.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2394.315673828125,
      "bbox_min": [
        -2394.315673828125,
        -4064.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2500.0,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1017.5
      ],
      "bbox_max": [
        -2500.0,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2518.815673828125,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2500.0,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2518.815673828125,
        -4064.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2500.0,
        -4045.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2508.815673828125,
      "bbox_min": [
        -2508.815673828125,
        -4064.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2500.0,
        -4056.199951171875,
        1049.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -2508.815673828125,
        -4064.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2500.0,
        -4056.199951171875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -2518.815673828125,
        -4056.199951171875,
        1032.0
      ],
      "bbox_max": [
        -2500.0,
        -4045.300048828125,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6644193530082703,
        -0.7473599910736084
      ],
      "plane_d": -1860.18310546875,
      "bbox_min": [
        -2530.148681640625,
        -4044.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2411.300048828125,
      "bbox_min": [
        -2530.148681640625,
        -4044.300048828125,
        988.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2394.315673828125,
      "bbox_min": [
        -2411.300048828125,
        -4044.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -4020.300048828125,
        1049.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -2411.300048828125,
        -4044.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2394.315673828125,
        -4020.300048828125,
        1049.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2410.0,
      "bbox_min": [
        -2411.300048828125,
        -4044.300048828125,
        1032.0
      ],
      "bbox_max": [
        -2410.0,
        -4020.300048828125,
        1049.123779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1037.0,
      "bbox_min": [
        -2411.300048828125,
        -4036.0,
        1037.0
      ],
      "bbox_max": [
        -2410.0,
        -4024.0,
        1043.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1043.0,
      "bbox_min": [
        -2411.300048828125,
        -4036.0,
        1037.0
      ],
      "bbox_max": [
        -2410.0,
        -4024.0,
        1043.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4036.0,
      "bbox_min": [
        -2411.300048828125,
        -4036.0,
        1037.0
      ],
      "bbox_max": [
        -2410.0,
        -4024.0,
        1043.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4024.0,
      "bbox_min": [
        -2411.300048828125,
        -4024.0,
        1037.0
      ],
      "bbox_max": [
        -2410.0,
        -4024.0,
        1043.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2521.800048828125,
      "bbox_min": [
        -2530.148681640625,
        -4044.300048828125,
        988.0
      ],
      "bbox_max": [
        -2411.300048828125,
        -3966.530029296875,
        1052.5999755859375
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1032.0
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1032.0
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4036.266357421875,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1032.0
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1032.0,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1032.0
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1049.123779296875,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        988.0
      ],
      "bbox_max": [
        -2411.300048828125,
        -3979.800048828125,
        1052.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7057713866233826,
        0.7084397077560425,
        0.0
      ],
      "plane_d": 1093.8336181640625,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7059481143951416,
        -0.708263635635376,
        0.0
      ],
      "plane_d": -4555.8671875,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7059481143951416,
        0.708263635635376,
        0.0
      ],
      "plane_d": 1138.77978515625,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082674503326416,
        -0.705944299697876,
        0.0
      ],
      "plane_d": -1103.8096923828125,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2434.39990234375,
        -4006.00439453125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082674503326416,
        0.705944299697876,
        -0.0
      ],
      "plane_d": 4572.189453125,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2434.39990234375,
        -4020.146484375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7057713866233826,
        -0.7084397077560425,
        0.0
      ],
      "plane_d": -4602.2294921875,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2485.50439453125,
        -4006.00439453125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7084447145462036,
        -0.7057663202285767,
        0.0
      ],
      "plane_d": -1056.40380859375,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2499.699951171875,
        -4006.00439453125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7084447145462036,
        0.7057663202285767,
        -0.0
      ],
      "plane_d": 4618.1640625,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1049.123779296875
      ],
      "bbox_max": [
        -2499.699951171875,
        -4020.146484375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1031.0,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3981.7421875,
        1043.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1031.9998779296875,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2419.453369140625,
        -3981.7421875,
        1043.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -6.0475096688605845e-05,
        0.0
      ],
      "plane_d": 2419.212646484375,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2419.453369140625,
        -3981.7421875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.047485294402577e-05,
        0.0
      ],
      "plane_d": -2421.212646484375,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2419.453369140625,
        -3981.7421875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.394531060825102e-05,
        1.0,
        0.0
      ],
      "plane_d": 3981.850830078125,
      "bbox_min": [
        -2421.453369140625,
        -3981.744384765625,
        1031.0
      ],
      "bbox_max": [
        -2419.453369140625,
        -3981.744384765625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        9.765624781721272e-06,
        0.0
      ],
      "plane_d": -2469.41455078125,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2421.453369140625,
        -3981.7421875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -9.765624781721272e-06,
        0.0
      ],
      "plane_d": 2467.414794921875,
      "bbox_min": [
        -2469.453857421875,
        -4033.742431640625,
        1031.0
      ],
      "bbox_max": [
        -2421.453369140625,
        -3981.7421875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.394531060825102e-05,
        1.0,
        0.0
      ],
      "plane_d": 3981.850830078125,
      "bbox_min": [
        -2469.453857421875,
        -4033.742431640625,
        1031.0
      ],
      "bbox_max": [
        -2467.45361328125,
        -3981.7421875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0313053280697204e-05,
        -1.0,
        -0.0
      ],
      "plane_d": -4033.767822265625,
      "bbox_min": [
        -2469.453857421875,
        -4033.742431640625,
        1031.0
      ],
      "bbox_max": [
        -2467.4541015625,
        -4033.742431640625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.394531060825102e-05,
        1.0,
        0.0
      ],
      "plane_d": 3981.850830078125,
      "bbox_min": [
        -2467.45361328125,
        -3983.744140625,
        1031.0
      ],
      "bbox_max": [
        -2421.453369140625,
        -3981.7421875,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7151836295379326e-05,
        -1.0,
        0.0
      ],
      "plane_d": -3983.833984375,
      "bbox_min": [
        -2467.45361328125,
        -3983.744140625,
        1031.0
      ],
      "bbox_max": [
        -2421.45361328125,
        -3983.742431640625,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.383928055380238e-06,
        1.0,
        0.0
      ],
      "plane_d": 4031.75537109375,
      "bbox_min": [
        -2521.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2469.453857421875,
        -4024.0,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0313053280697204e-05,
        -1.0,
        -0.0
      ],
      "plane_d": -4033.767822265625,
      "bbox_min": [
        -2514.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2469.453857421875,
        -4031.741943359375,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2514.800048828125,
      "bbox_min": [
        -2514.800048828125,
        -4033.741943359375,
        1031.0
      ],
      "bbox_max": [
        -2514.800048828125,
        -4031.741943359375,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2514.800048828125,
      "bbox_min": [
        -2514.800048828125,
        -4044.300048828125,
        1031.0
      ],
      "bbox_max": [
        -2514.800048828125,
        -4033.741943359375,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2514.800048828125,
      "bbox_min": [
        -2521.800048828125,
        -4031.741943359375,
        1031.0
      ],
      "bbox_max": [
        -2514.800048828125,
        -4024.0,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4024.0,
      "bbox_min": [
        -2521.800048828125,
        -4024.0,
        1031.0
      ],
      "bbox_max": [
        -2514.800048828125,
        -4024.0,
        1032.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2520.699951171875,
      "bbox_min": [
        -2521.800048828125,
        -4036.300048828125,
        1041.5999755859375
      ],
      "bbox_max": [
        -2520.699951171875,
        -4028.199951171875,
        1043.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1043.5,
      "bbox_min": [
        -2521.800048828125,
        -4036.300048828125,
        1041.5999755859375
      ],
      "bbox_max": [
        -2520.699951171875,
        -4028.199951171875,
        1043.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1041.5999755859375,
      "bbox_min": [
        -2521.800048828125,
        -4036.300048828125,
        1041.5999755859375
      ],
      "bbox_max": [
        -2520.699951171875,
        -4028.199951171875,
        1043.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4036.300048828125,
      "bbox_min": [
        -2521.800048828125,
        -4036.300048828125,
        1041.5999755859375
      ],
      "bbox_max": [
        -2520.699951171875,
        -4028.199951171875,
        1043.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4028.199951171875,
      "bbox_min": [
        -2521.800048828125,
        -4028.199951171875,
        1041.5999755859375
      ],
      "bbox_max": [
        -2520.699951171875,
        -4028.199951171875,
        1043.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9191450476646423,
        -0.0,
        0.39391931891441345
      ],
      "plane_d": 1884.7725830078125,
      "bbox_min": [
        -2516.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9191450476646423,
        -0.0,
        0.39391931891441345
      ],
      "plane_d": 1911.4278564453125,
      "bbox_min": [
        -2516.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2474.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        0.0,
        0.39391931891441345
      ],
      "plane_d": -2701.76123046875,
      "bbox_min": [
        -2516.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2503.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -995.0,
      "bbox_min": [
        -2516.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2503.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4040.0,
      "bbox_min": [
        -2516.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2503.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -2516.0,
        -3985.0,
        988.0
      ],
      "bbox_max": [
        -2503.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        0.0,
        0.39391931891441345
      ],
      "plane_d": -2675.106201171875,
      "bbox_min": [
        -2487.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2474.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -995.0,
      "bbox_min": [
        -2487.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2474.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4040.0,
      "bbox_min": [
        -2487.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2474.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -2487.0,
        -3985.0,
        988.0
      ],
      "bbox_max": [
        -2474.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        0.0,
        0.39391931891441345
      ],
      "plane_d": -2622.71484375,
      "bbox_min": [
        -2458.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9191450476646423,
        -0.0,
        0.39391931891441345
      ],
      "plane_d": 1832.3812255859375,
      "bbox_min": [
        -2430.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -995.0,
      "bbox_min": [
        -2430.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4040.0,
      "bbox_min": [
        -2430.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -2430.0,
        -3985.0,
        988.0
      ],
      "bbox_max": [
        -2417.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9191450476646423,
        -0.0,
        0.39391931891441345
      ],
      "plane_d": 1858.1173095703125,
      "bbox_min": [
        -2458.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2445.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9191450476646423,
        0.0,
        0.39391931891441345
      ],
      "plane_d": -2648.450927734375,
      "bbox_min": [
        -2458.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2445.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -995.0,
      "bbox_min": [
        -2458.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2445.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4040.0,
      "bbox_min": [
        -2458.0,
        -4040.0,
        988.0
      ],
      "bbox_max": [
        -2445.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -2458.0,
        -3985.0,
        988.0
      ],
      "bbox_max": [
        -2445.0,
        -3985.0,
        995.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2752.65576171875,
        -4244.69189453125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2018.78173828125,
        -3134.806640625,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2752.65576171875,
        -4244.69189453125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -3925.654541015625,
        1151.3204345703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2579.205322265625,
        -4056.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -3981.623291015625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2518.815673828125,
      "bbox_min": [
        -2579.205322265625,
        -4056.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -3981.623291015625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2579.205322265625,
        -4056.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2518.815673828125,
        -3981.623291015625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4054.119140625,
        1082.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -3981.623291015625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2535.894287109375,
        -4054.119140625,
        1101.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4048.4697265625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2535.894287109375,
        -4051.410888671875,
        1101.623779296875
      ],
      "bbox_max": [
        -2532.423828125,
        -4048.4697265625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.894287109375,
        -4050.8056640625,
        1102.2750244140625
      ],
      "bbox_max": [
        -2535.88818359375,
        -4050.221435546875,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 222.9329833984375,
      "bbox_min": [
        -2579.205322265625,
        -4049.783203125,
        1082.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -3981.623291015625,
        1101.7984619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660240173339844,
        0.500002384185791,
        0.0
      ],
      "plane_d": -188.1138916015625,
      "bbox_min": [
        -2574.875,
        -4049.783203125,
        1082.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -3991.91748046875,
        1101.7984619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866024374961853,
        0.5000017881393433,
        0.0
      ],
      "plane_d": -183.11734008789062,
      "bbox_min": [
        -2544.737548828125,
        -4049.783203125,
        1082.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4018.94189453125,
        1101.7984619140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2532.423828125,
        -4049.783203125,
        1101.623779296875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4047.817138671875,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2532.423828125,
        -4048.4697265625,
        1101.623779296875
      ],
      "bbox_max": [
        -2531.887939453125,
        -4047.817138671875,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8743192553520203,
        -0.48535144329071045,
        0.0
      ],
      "plane_d": -4169.24365234375,
      "bbox_min": [
        -2537.567626953125,
        -4024.0400390625,
        1082.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4018.94189453125,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660240173339844,
        -0.500002384185791,
        0.0
      ],
      "plane_d": 217.913818359375,
      "bbox_min": [
        -2574.875,
        -4023.96044921875,
        1082.623779296875
      ],
      "bbox_max": [
        -2556.375,
        -3991.91748046875,
        1101.7984619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01678922399878502,
        -0.999859094619751,
        0.0
      ],
      "plane_d": -3960.440673828125,
      "bbox_min": [
        -2569.205322265625,
        -4004.139892578125,
        1082.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1097.6080322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4036.266357421875,
      "bbox_min": [
        -2530.148681640625,
        -4056.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2518.815673828125,
        -4028.199951171875,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2530.148681640625,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2518.815673828125,
        -4048.8212890625,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0032432021107524633,
        0.9999947547912598,
        0.0
      ],
      "plane_d": 4064.34765625,
      "bbox_min": [
        -2526.588623046875,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2518.815673828125,
        -4056.1748046875,
        1102.5850830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2521.800048828125,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1098.47119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2530.148681640625,
        -4028.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1097.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4044.300048828125,
      "bbox_min": [
        -2518.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1100.727783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1054.123779296875,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7057713866233826,
        0.7084397077560425,
        0.0
      ],
      "plane_d": 1093.8336181640625,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7059481143951416,
        -0.708263635635376,
        0.0
      ],
      "plane_d": -4555.8671875,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7059481143951416,
        0.708263635635376,
        0.0
      ],
      "plane_d": 1138.77978515625,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2420.21142578125,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082674503326416,
        -0.705944299697876,
        0.0
      ],
      "plane_d": -1103.8096923828125,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2434.39990234375,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082674503326416,
        0.705944299697876,
        -0.0
      ],
      "plane_d": 4572.189453125,
      "bbox_min": [
        -2448.49560546875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2434.39990234375,
        -4020.146484375,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7057713866233826,
        -0.7084397077560425,
        0.0
      ],
      "plane_d": -4602.2294921875,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2485.50439453125,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7084447145462036,
        -0.7057663202285767,
        0.0
      ],
      "plane_d": -1056.40380859375,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2499.699951171875,
        -4006.00439453125,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7084447145462036,
        0.7057663202285767,
        -0.0
      ],
      "plane_d": 4618.1640625,
      "bbox_min": [
        -2513.78857421875,
        -4034.28857421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2499.699951171875,
        -4020.146484375,
        1054.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2508.815673828125,
      "bbox_min": [
        -2508.815673828125,
        -4056.199951171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1100.727783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -2705.027099609375,
        -4244.69189453125,
        1094.623779296875
      ],
      "bbox_max": [
        -2518.247802734375,
        -4020.422607421875,
        1151.3204345703125
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.623779296875,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1094.623779296875
      ],
      "bbox_max": [
        -2518.247802734375,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.38810741901397705,
        0.22407330572605133,
        0.8939595818519592
      ],
      "plane_d": -1051.5078125,
      "bbox_min": [
        -2544.672119140625,
        -4082.407958984375,
        1094.623779296875
      ],
      "bbox_max": [
        -2537.85107421875,
        -4076.0830078125,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500051736831665,
        0.8659955263137817,
        2.2711633462790815e-08
      ],
      "plane_d": 4805.654296875,
      "bbox_min": [
        -2544.672119140625,
        -4082.407958984375,
        1094.623779296875
      ],
      "bbox_max": [
        -2540.35107421875,
        -4079.9130859375,
        1096.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -149.794189453125,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252690315247,
        -0.5000002980232239,
        0.0
      ],
      "plane_d": 162.79263305664062,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000134706497192,
        0.8660176396369934,
        1.6161244275281206e-05
      ],
      "plane_d": 4805.6298828125,
      "bbox_min": [
        -2563.7666015625,
        -4080.4130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7426072955131531,
        -0.4287433326244354,
        0.5145031809806824
      ],
      "plane_d": -407.4259033203125,
      "bbox_min": [
        -2563.7666015625,
        -4076.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4047.23828125,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6123876571655273,
        -0.3535628616809845,
        0.707088828086853
      ],
      "plane_d": -648.6296997070312,
      "bbox_min": [
        -2557.7275390625,
        -4076.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4047.838134765625,
        1101.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2557.7275390625,
        -4062.002685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2548.193603515625,
        -4047.838134765625,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48038366436958313,
        0.2773498594760895,
        0.8320508599281311
      ],
      "plane_d": -1010.3748779296875,
      "bbox_min": [
        -2556.796630859375,
        -4076.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4053.762451171875,
        1101.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 171.79991149902344,
      "bbox_min": [
        -2553.33251953125,
        -4076.9130859375,
        1098.123779296875
      ],
      "bbox_max": [
        -2547.368408203125,
        -4070.3330078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 173.80001831054688,
      "bbox_min": [
        -2553.33251953125,
        -4075.9130859375,
        1098.123779296875
      ],
      "bbox_max": [
        -2549.100341796875,
        -4070.3330078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2551.265625,
        -4070.5830078125,
        1098.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4070.3330078125,
        1098.45703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2551.817138671875,
        -4075.9130859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.100341796875,
        -4071.0830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2549.96630859375,
        -4071.5830078125,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.100341796875,
        -4071.0830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.623779296875,
      "bbox_min": [
        -2550.51806640625,
        -4076.9130859375,
        1100.123779296875
      ],
      "bbox_max": [
        -2547.368408203125,
        -4071.8330078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2548.66748046875,
        -4072.5830078125,
        1100.123779296875
      ],
      "bbox_max": [
        -2547.368408203125,
        -4071.8330078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1098.623779296875,
      "bbox_min": [
        -2556.796630859375,
        -4076.5380859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2548.01806640625,
        -4068.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1097.623779296875,
      "bbox_min": [
        -2556.796630859375,
        -4074.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4068.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 175.79991149902344,
      "bbox_min": [
        -2555.064453125,
        -4073.9130859375,
        1097.123779296875
      ],
      "bbox_max": [
        -2552.564453125,
        -4068.5830078125,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2554.296630859375,
        -4069.5830078125,
        1097.123779296875
      ],
      "bbox_max": [
        -2552.564453125,
        -4068.5830078125,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 173.80001831054688,
      "bbox_min": [
        -2553.33251953125,
        -4074.9130859375,
        1098.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4069.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2552.564453125,
        -4070.5830078125,
        1098.123779296875
      ],
      "bbox_max": [
        -2550.83251953125,
        -4069.5830078125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2553.33251953125,
        -4076.5380859375,
        1099.123779296875
      ],
      "bbox_max": [
        -2548.01806640625,
        -4070.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2550.83251953125,
        -4071.4580078125,
        1099.123779296875
      ],
      "bbox_max": [
        -2549.31689453125,
        -4070.5830078125,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.623779296875,
      "bbox_min": [
        -2551.600341796875,
        -4076.5380859375,
        1100.123779296875
      ],
      "bbox_max": [
        -2548.01806640625,
        -4071.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4800.64404296875,
      "bbox_min": [
        -2549.100341796875,
        -4072.2080078125,
        1100.123779296875
      ],
      "bbox_max": [
        -2548.01806640625,
        -4071.5830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660252690315247,
        -0.5000002980232239,
        0.0
      ],
      "plane_d": 159.79257202148438,
      "bbox_min": [
        -2543.80615234375,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4058.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4803895056247711,
        -0.2773532271385193,
        0.8320463299751282
      ],
      "plane_d": -825.8839721679688,
      "bbox_min": [
        -2543.80615234375,
        -4081.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2543.80615234375,
        -4081.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.1239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000121593475342,
        0.8660183548927307,
        0.0
      ],
      "plane_d": 4800.646484375,
      "bbox_min": [
        -2541.30615234375,
        -4076.8330078125,
        1100.123779296875
      ],
      "bbox_max": [
        -2540.007080078125,
        -4076.0830078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4780.64453125,
      "bbox_min": [
        -2543.80615234375,
        -4081.9130859375,
        1099.1236572265625
      ],
      "bbox_max": [
        -2528.7080078125,
        -4058.762451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866025984287262,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 160.800048828125,
      "bbox_min": [
        -2542.07421875,
        -4081.4130859375,
        1100.123779296875
      ],
      "bbox_max": [
        -2539.57421875,
        -4076.4580078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000121593475342,
        0.8660183548927307,
        0.0
      ],
      "plane_d": 4800.646484375,
      "bbox_min": [
        -2540.656494140625,
        -4077.0830078125,
        1100.123779296875
      ],
      "bbox_max": [
        -2539.57421875,
        -4076.4580078125,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        -0.8660248517990112,
        -0.0
      ],
      "plane_d": -4780.64453125,
      "bbox_min": [
        -2541.2080078125,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4060.262451171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2541.2080078125,
        -4086.9130859375,
        1096.623779296875
      ],
      "bbox_max": [
        -2532.5478515625,
        -4081.9130859375,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7037546038627625,
        -0.40631303191185,
        -0.5827857255935669
      ],
      "plane_d": 831.0966186523438,
      "bbox_min": [
        -2705.027099609375,
        -4228.44189453125,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4020.422607421875,
        1151.3204345703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7892688512802124,
        -0.45568472146987915,
        0.411590039730072
      ],
      "plane_d": -262.6591796875,
      "bbox_min": [
        -2705.027099609375,
        -4228.44189453125,
        1101.623779296875
      ],
      "bbox_max": [
        -2598.03564453125,
        -4020.422607421875,
        1151.3204345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 246.770751953125,
      "bbox_min": [
        -2622.712646484375,
        -4043.330078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2598.03564453125,
        -4020.422607421875,
        1109.834716796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999936819076538,
        0.8660290837287903,
        0.0
      ],
      "plane_d": 4800.64306640625,
      "bbox_min": [
        -2622.712646484375,
        -4034.0830078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2614.05224609375,
        -4020.422607421875,
        1107.739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660290837287903,
        -0.4999936819076538,
        0.0
      ],
      "plane_d": 256.8294677734375,
      "bbox_min": [
        -2622.712646484375,
        -4029.0830078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2617.712646484375,
        -4020.422607421875,
        1107.739501953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999959468841553,
        0.8660277724266052,
        1.17841018436593e-05
      ],
      "plane_d": 4800.63037109375,
      "bbox_min": [
        -2603.659912109375,
        -4043.330078125,
        1101.623779296875
      ],
      "bbox_max": [
        -2598.03564453125,
        -4040.0830078125,
        1107.739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027090430259705,
        -0.46344417333602905,
        0.37533676624298096
      ],
      "plane_d": -209.24647521972656,
      "bbox_min": [
        -2638.224365234375,
        -4122.171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4025.809814453125,
        1112.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4999959468841553,
        0.8660277724266052,
        1.17841018436593e-05
      ],
      "plane_d": 4800.63037109375,
      "bbox_min": [
        -2601.834228515625,
        -4047.30859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2591.14453125,
        -4041.13720703125,
        1107.739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998968839645386,
        0.8660314083099365,
        2.089589906972833e-05
      ],
      "plane_d": 4820.619140625,
      "bbox_min": [
        -2571.2666015625,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2560.368408203125,
        -4102.599609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2546.03369140625,
        -4089.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 169.8492431640625,
      "bbox_min": [
        -2560.368408203125,
        -4095.099609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2557.368408203125,
        -4089.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000054836273193,
        0.8660222887992859,
        0.0
      ],
      "plane_d": 4805.6455078125,
      "bbox_min": [
        -2563.7666015625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1109.834716796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 169.7708740234375,
      "bbox_min": [
        -2552.368408203125,
        -4084.7431640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2543.80615234375,
        -4076.9130859375,
        1109.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -162.770751953125,
      "bbox_min": [
        -2546.30615234375,
        -4084.7431640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2543.80615234375,
        -4080.4130859375,
        1109.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000016093254089,
        -0.8660244941711426,
        0.0
      ],
      "plane_d": -4780.64501953125,
      "bbox_min": [
        -2551.600341796875,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.23828125,
        1108.787109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -162.8487548828125,
      "bbox_min": [
        -2537.368408203125,
        -4058.762451171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2526.588623046875,
        -4050.8056640625,
        1103.5489501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 169.8487548828125,
      "bbox_min": [
        -2537.368408203125,
        -4055.262451171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2534.839111328125,
        -4050.8056640625,
        1103.5489501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.88818359375,
        -4052.664306640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2535.868408203125,
        -4050.8056640625,
        1102.9202880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2535.868408203125,
        -4052.664306640625,
        1101.623779296875
      ],
      "bbox_max": [
        -2534.839111328125,
        -4051.410888671875,
        1102.9202880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5510034561157227,
        0.8345029950141907,
        0.0
      ],
      "plane_d": 1995.4210205078125,
      "bbox_min": [
        -2551.600341796875,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4054.262451171875,
        1108.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9982051849365234,
        -0.05988685414195061,
        0.0
      ],
      "plane_d": 2301.138427734375,
      "bbox_min": [
        -2551.600341796875,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1108.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4804.64404296875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1108.57763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22360868752002716,
        0.3873026669025421,
        -0.8944248557090759
      ],
      "plane_d": 3134.49169921875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1102.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882023572921753,
        0.9659255146980286,
        0.0
      ],
      "plane_d": 3292.178955078125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1108.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025984287262,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -148.80010986328125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1108.5775146484375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.866025984287262,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -150.7999725341797,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1107.5299072265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25882023572921753,
        0.9659255146980286,
        0.0
      ],
      "plane_d": 3285.10791015625,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1106.9013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        -0.7071075439453125
      ],
      "plane_d": 673.0421142578125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2527.5478515625,
        -4078.252685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        0.7071075439453125
      ],
      "plane_d": -884.890869140625,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.681884765625,
        -4082.5830078125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123682260513306,
        0.35355493426322937,
        0.7071096897125244
      ],
      "plane_d": -884.8724975585938,
      "bbox_min": [
        -2527.5478515625,
        -4078.252685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1105.853759765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        -0.7071075439453125
      ],
      "plane_d": 673.0420532226562,
      "bbox_min": [
        -2525.413818359375,
        -4075.28857421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1105.853759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        -0.25882023572921753,
        -0.0
      ],
      "plane_d": -3493.421875,
      "bbox_min": [
        -2525.413818359375,
        -4075.28857421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1105.853759765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25882023572921753,
        0.9659255146980286,
        0.0
      ],
      "plane_d": 3278.036865234375,
      "bbox_min": [
        -2523.913818359375,
        -4069.95849609375,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1104.8060302734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        -0.25882023572921753,
        -0.0
      ],
      "plane_d": -3486.3505859375,
      "bbox_min": [
        -2520.0478515625,
        -4066.62841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5509783625602722,
        -0.8345195651054382,
        0.0
      ],
      "plane_d": -1986.1607666015625,
      "bbox_min": [
        -2539.16748046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4054.262451171875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9982019066810608,
        0.05994124338030815,
        0.0
      ],
      "plane_d": -2291.517333984375,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2236163318157196,
        -0.3872886300086975,
        -0.894429087638855
      ],
      "plane_d": -1152.6297607421875,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        -0.0
      ],
      "plane_d": -4781.64404296875,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1102.123779296875
      ],
      "bbox_max": [
        -2538.30126953125,
        -4055.37841796875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9982019066810608,
        0.05994124338030815,
        0.0
      ],
      "plane_d": -2283.46728515625,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5510034561157227,
        -0.8345029950141907,
        0.0
      ],
      "plane_d": -1994.079833984375,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1101.623779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4059.762451171875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        -0.0
      ],
      "plane_d": -4781.64404296875,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1102.123779296875
      ],
      "bbox_max": [
        -2530.507080078125,
        -4059.87841796875,
        1103.758544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2752.65576171875,
        -4221.736328125,
        1092.160400390625
      ],
      "bbox_max": [
        -2018.78173828125,
        -3134.806640625,
        1534.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2579.205322265625,
        -4056.199951171875,
        1092.160400390625
      ],
      "bbox_max": [
        -2018.78173828125,
        -3134.806640625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2144.25732421875,
        -3234.538818359375,
        1428.4024658203125
      ],
      "bbox_max": [
        -2084.453369140625,
        -3176.007568359375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 222.9329833984375,
      "bbox_min": [
        -2579.205322265625,
        -4056.199951171875,
        1092.160400390625
      ],
      "bbox_max": [
        -2508.815673828125,
        -3981.623291015625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660281896591187,
        0.4999951720237732,
        0.0
      ],
      "plane_d": -188.1534423828125,
      "bbox_min": [
        -2579.205322265625,
        -4056.199951171875,
        1094.0460205078125
      ],
      "bbox_max": [
        -2508.815673828125,
        -3991.91748046875,
        1166.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8743192553520203,
        -0.48535144329071045,
        0.0
      ],
      "plane_d": -4169.24365234375,
      "bbox_min": [
        -2549.067626953125,
        -4056.199951171875,
        1096.9793701171875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4018.94189453125,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4036.266357421875,
      "bbox_min": [
        -2532.428466796875,
        -4056.199951171875,
        1097.0074462890625
      ],
      "bbox_max": [
        -2508.815673828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4044.300048828125,
      "bbox_min": [
        -2523.4912109375,
        -4056.199951171875,
        1098.568603515625
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2523.4912109375,
        -4056.199951171875,
        1099.6160888671875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2523.4912109375,
        -4056.199951171875,
        1099.6160888671875
      ],
      "bbox_max": [
        -2508.815673828125,
        -4044.300048828125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2518.815673828125,
      "bbox_min": [
        -2518.815673828125,
        -4052.72265625,
        1099.6160888671875
      ],
      "bbox_max": [
        -2518.815673828125,
        -4044.300048828125,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2521.800048828125,
      "bbox_min": [
        -2532.428466796875,
        -4036.266357421875,
        1097.0074462890625
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2532.428466796875,
        -4036.266357421875,
        1097.0074462890625
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.462159343645908e-05,
        0.0,
        -1.0
      ],
      "plane_d": 1115.5869140625,
      "bbox_min": [
        -2532.428466796875,
        -4036.266357421875,
        1097.882080078125
      ],
      "bbox_max": [
        -2521.800048828125,
        -4028.199951171875,
        1115.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2532.428466796875,
        -4032.306640625,
        1097.882080078125
      ],
      "bbox_max": [
        -2530.148681640625,
        -4028.199951171875,
        1104.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.6239013671875,
      "bbox_min": [
        -2532.428466796875,
        -4032.306640625,
        1104.6239013671875
      ],
      "bbox_max": [
        -2530.148681640625,
        -4028.199951171875,
        1104.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2549.067626953125,
        -4056.199951171875,
        1097.6080322265625
      ],
      "bbox_max": [
        -2516.885009765625,
        -4018.94189453125,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2522.0,
        -4056.199951171875,
        1105.0
      ],
      "bbox_max": [
        -2521.0,
        -4056.199951171875,
        1107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2535.93408203125,
        -4056.19921875,
        1101.79833984375
      ],
      "bbox_max": [
        -2519.03564453125,
        -4046.44287109375,
        1114.8037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.93408203125,
        -4050.805419921875,
        1112.623779296875
      ],
      "bbox_max": [
        -2535.887939453125,
        -4046.44287109375,
        1114.8037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2535.93408203125,
        -4051.410888671875,
        1101.79833984375
      ],
      "bbox_max": [
        -2532.423828125,
        -4046.44287109375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.93408203125,
        -4050.8056640625,
        1102.479736328125
      ],
      "bbox_max": [
        -2535.887939453125,
        -4046.44287109375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866015613079071,
        0.5000169277191162,
        0.0
      ],
      "plane_d": -183.0341796875,
      "bbox_min": [
        -2549.067626953125,
        -4056.199951171875,
        1097.6080322265625
      ],
      "bbox_max": [
        -2516.885009765625,
        -4018.94189453125,
        1142.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4036.266357421875,
      "bbox_min": [
        -2539.90771484375,
        -4056.199951171875,
        1098.6273193359375
      ],
      "bbox_max": [
        -2516.885009765625,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2535.958740234375,
        -4056.199951171875,
        1101.1444091796875
      ],
      "bbox_max": [
        -2516.885009765625,
        -4044.102294921875,
        1115.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.958740234375,
        -4046.44287109375,
        1112.623779296875
      ],
      "bbox_max": [
        -2535.93408203125,
        -4044.102294921875,
        1115.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.958740234375,
        -4046.44287109375,
        1103.8037109375
      ],
      "bbox_max": [
        -2535.93408203125,
        -4044.102294921875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2518.815673828125,
      "bbox_min": [
        -2518.815673828125,
        -4056.199951171875,
        1101.1444091796875
      ],
      "bbox_max": [
        -2516.885009765625,
        -4052.72265625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2517.36865234375,
        -4056.199951171875,
        1101.5731201171875
      ],
      "bbox_max": [
        -2516.885009765625,
        -4056.199951171875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4056.199951171875,
      "bbox_min": [
        -2519.03564453125,
        -4056.199951171875,
        1101.623779296875
      ],
      "bbox_max": [
        -2516.885009765625,
        -4056.19921875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2717772424221039,
        0.9623602032661438,
        0.0
      ],
      "plane_d": 4571.97900390625,
      "bbox_min": [
        -2539.90771484375,
        -4036.266357421875,
        1098.6273193359375
      ],
      "bbox_max": [
        -2527.950439453125,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015212297439575,
        0.8651454448699951,
        0.0
      ],
      "plane_d": 4762.94482421875,
      "bbox_min": [
        -2539.90771484375,
        -4036.266357421875,
        1098.6273193359375
      ],
      "bbox_max": [
        -2527.950439453125,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.6239013671875,
      "bbox_min": [
        -2539.90771484375,
        -4036.266357421875,
        1098.6273193359375
      ],
      "bbox_max": [
        -2527.950439453125,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2530.148681640625,
      "bbox_min": [
        -2530.148681640625,
        -4036.266357421875,
        1098.6273193359375
      ],
      "bbox_max": [
        -2530.148681640625,
        -4032.306640625,
        1104.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -5.10749896420748e-06,
        -1.8085596821038052e-05,
        -1.0
      ],
      "plane_d": 1115.5379638671875,
      "bbox_min": [
        -2539.90771484375,
        -4036.266357421875,
        1104.6239013671875
      ],
      "bbox_max": [
        -2527.950439453125,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4028.199951171875,
      "bbox_min": [
        -2536.5556640625,
        -4028.199951171875,
        1104.6239013671875
      ],
      "bbox_max": [
        -2532.428466796875,
        -4027.18896484375,
        1115.6239013671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5014897584915161,
        -0.8651636242866516,
        0.0
      ],
      "plane_d": -4756.23388671875,
      "bbox_min": [
        -2536.5556640625,
        -4028.199951171875,
        1104.6239013671875
      ],
      "bbox_max": [
        -2534.8115234375,
        -4027.18896484375,
        1115.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2549.067626953125,
        -4041.3603515625,
        1104.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4018.94189453125,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2549.067626953125,
        -4041.3603515625,
        1104.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4018.94189453125,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660281896591187,
        -0.4999951720237732,
        0.0
      ],
      "plane_d": 217.953369140625,
      "bbox_min": [
        -2579.205322265625,
        -4038.860595703125,
        1094.046142578125
      ],
      "bbox_max": [
        -2531.61767578125,
        -3991.91748046875,
        1166.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01678922399878502,
        -0.999859094619751,
        0.0
      ],
      "plane_d": -3960.440673828125,
      "bbox_min": [
        -2579.205322265625,
        -4023.960693359375,
        1096.9793701171875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4023.960693359375,
        1101.7984619140625
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2579.205322265625,
        -4023.960693359375,
        1104.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2579.205322265625,
        -4023.96044921875,
        1104.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2574.875,
        -4038.860595703125,
        1101.7984619140625
      ],
      "bbox_max": [
        -2531.61767578125,
        -3993.736083984375,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1142.623779296875,
      "bbox_min": [
        -2574.875,
        -4038.860595703125,
        1142.623779296875
      ],
      "bbox_max": [
        -2531.61767578125,
        -3993.736083984375,
        1142.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7892688512802124,
        -0.45568472146987915,
        0.411590039730072
      ],
      "plane_d": -262.6591796875,
      "bbox_min": [
        -2705.536865234375,
        -4221.736328125,
        1102.5850830078125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4020.422607421875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7037639617919922,
        -0.4063149392604828,
        -0.5827730894088745
      ],
      "plane_d": 831.0990600585938,
      "bbox_min": [
        -2622.712646484375,
        -4105.69677734375,
        1102.5850830078125
      ],
      "bbox_max": [
        -2577.112548828125,
        -4020.422607421875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 246.770751953125,
      "bbox_min": [
        -2622.712646484375,
        -4045.08154296875,
        1105.644287109375
      ],
      "bbox_max": [
        -2590.002197265625,
        -4020.422607421875,
        1117.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2622.712646484375,
        -4034.0830078125,
        1105.644287109375
      ],
      "bbox_max": [
        -2609.05224609375,
        -4020.422607421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660290837287903,
        -0.4999936819076538,
        0.0
      ],
      "plane_d": 256.8294677734375,
      "bbox_min": [
        -2622.712646484375,
        -4034.0830078125,
        1105.644287109375
      ],
      "bbox_max": [
        -2614.05224609375,
        -4020.422607421875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999936819076538,
        0.8660290837287903,
        0.0
      ],
      "plane_d": 4800.64306640625,
      "bbox_min": [
        -2622.712646484375,
        -4034.0830078125,
        1107.739501953125
      ],
      "bbox_max": [
        -2614.05224609375,
        -4029.0830078125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2603.659912109375,
        -4045.08154296875,
        1107.739501953125
      ],
      "bbox_max": [
        -2590.002197265625,
        -4033.922607421875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000041723251343,
        0.8660229444503784,
        -4.2146666601183824e-08
      ],
      "plane_d": 4800.6455078125,
      "bbox_min": [
        -2603.659912109375,
        -4042.5830078125,
        1112.623779296875
      ],
      "bbox_max": [
        -2599.329833984375,
        -4040.0830078125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999959468841553,
        0.8660277724266052,
        1.17841018436593e-05
      ],
      "plane_d": 4800.63037109375,
      "bbox_min": [
        -2603.659912109375,
        -4045.08154296875,
        1107.739501953125
      ],
      "bbox_max": [
        -2595.002197265625,
        -4040.0830078125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8027098178863525,
        -0.46344342827796936,
        0.375336229801178
      ],
      "plane_d": -209.24066162109375,
      "bbox_min": [
        -2606.657958984375,
        -4065.269775390625,
        1102.5850830078125
      ],
      "bbox_max": [
        -2579.181640625,
        -4023.77734375,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999959468841553,
        0.8660277724266052,
        1.17841018436593e-05
      ],
      "plane_d": 4800.63037109375,
      "bbox_min": [
        -2598.035400390625,
        -4046.0703125,
        1107.739501953125
      ],
      "bbox_max": [
        -2593.289306640625,
        -4043.330322265625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44057026505470276,
        0.25436335802078247,
        -0.8609281182289124
      ],
      "plane_d": 883.8370971679688,
      "bbox_min": [
        -2567.65673828125,
        -4100.27099609375,
        1102.5850830078125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.627685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2567.65673828125,
        -4100.27099609375,
        1102.5850830078125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.627685546875,
        1121.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7570364475250244,
        -0.4370751976966858,
        -0.4856555461883545
      ],
      "plane_d": 688.7777099609375,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4050.805419921875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2535.887939453125,
        -4052.664306640625,
        1112.623779296875
      ],
      "bbox_max": [
        -2535.868408203125,
        -4050.805419921875,
        1113.275146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1121.623779296875,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        0.5,
        0.0
      ],
      "plane_d": -149.794189453125,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000009536743164,
        -0.8660248517990112,
        -2.8725271477014758e-06
      ],
      "plane_d": -4780.6416015625,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2520.0478515625,
        -4055.262451171875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        -0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2549.868408203125,
        -4086.9130859375,
        1112.623779296875
      ],
      "bbox_max": [
        -2532.5478515625,
        -4076.9130859375,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8028455972671509,
        -0.46352311968803406,
        -0.37494704127311707
      ],
      "plane_d": 585.3353271484375,
      "bbox_min": [
        -2567.65673828125,
        -4092.771240234375,
        1102.5850830078125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.627685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000016093254089,
        -0.8660244941711426,
        0.0
      ],
      "plane_d": -4780.64501953125,
      "bbox_min": [
        -2567.65673828125,
        -4092.771240234375,
        1102.5850830078125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4047.627685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0032432021107524633,
        0.9999947547912598,
        0.0
      ],
      "plane_d": 4064.34765625,
      "bbox_min": [
        -2537.368408203125,
        -4058.762451171875,
        1102.5850830078125
      ],
      "bbox_max": [
        -2526.588623046875,
        -4050.805419921875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660311102867126,
        0.4999901354312897,
        0.0
      ],
      "plane_d": -162.8487548828125,
      "bbox_min": [
        -2531.30615234375,
        -4058.762451171875,
        1102.92041015625
      ],
      "bbox_max": [
        -2529.80615234375,
        -4056.164306640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999443292617798,
        0.010549741797149181,
        0.0
      ],
      "plane_d": 2578.481689453125,
      "bbox_min": [
        -2537.368408203125,
        -4055.262451171875,
        1102.5850830078125
      ],
      "bbox_max": [
        -2534.839111328125,
        -4050.805419921875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 169.8487548828125,
      "bbox_min": [
        -2537.368408203125,
        -4055.262451171875,
        1102.9202880859375
      ],
      "bbox_max": [
        -2535.868408203125,
        -4052.664306640625,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7728275060653687,
        -0.6346163153648376,
        0.0
      ],
      "plane_d": -612.09814453125,
      "bbox_min": [
        -2535.868408203125,
        -4052.664306640625,
        1102.5850830078125
      ],
      "bbox_max": [
        -2534.839111328125,
        -4051.410888671875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000010132789612,
        0.8660248517990112,
        -0.0
      ],
      "plane_d": 4805.64501953125,
      "bbox_min": [
        -2567.65673828125,
        -4092.771240234375,
        1103.5489501953125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49998968839645386,
        0.8660314083099365,
        2.089589906972833e-05
      ],
      "plane_d": 4820.619140625,
      "bbox_min": [
        -2567.65673828125,
        -4092.771240234375,
        1108.7869873046875
      ],
      "bbox_max": [
        -2543.80615234375,
        -4076.9130859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660311102867126,
        -0.4999901354312897,
        0.0
      ],
      "plane_d": 169.8492431640625,
      "bbox_min": [
        -2559.024169921875,
        -4092.771240234375,
        1111.929931640625
      ],
      "bbox_max": [
        -2557.368408203125,
        -4089.9033203125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -162.770751953125,
      "bbox_min": [
        -2552.368408203125,
        -4084.7431640625,
        1108.7869873046875
      ],
      "bbox_max": [
        -2543.80615234375,
        -4076.9130859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 169.7708740234375,
      "bbox_min": [
        -2552.368408203125,
        -4081.2431640625,
        1108.787109375
      ],
      "bbox_max": [
        -2549.868408203125,
        -4076.9130859375,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9982019066810608,
        0.05994124338030815,
        0.0
      ],
      "plane_d": -2283.46728515625,
      "bbox_min": [
        -2551.600341796875,
        -4086.9130859375,
        1103.5489501953125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5510034561157227,
        -0.8345029950141907,
        0.0
      ],
      "plane_d": -1994.079833984375,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1103.5489501953125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        -0.0
      ],
      "plane_d": -4781.64404296875,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1103.758544921875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22361324727535248,
        -0.3872969150543213,
        0.894426167011261
      ],
      "plane_d": -3133.1396484375,
      "bbox_min": [
        -2531.373046875,
        -4060.37841796875,
        1112.123779296875
      ],
      "bbox_max": [
        -2529.57421875,
        -4058.762451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        -0.25882023572921753,
        -0.0
      ],
      "plane_d": -3486.3505859375,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1103.5489501953125
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866025984287262,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -148.79998779296875,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1103.758544921875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25882023572921753,
        0.9659255146980286,
        0.0
      ],
      "plane_d": 3278.036865234375,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1104.3870849609375
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866025984287262,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -150.79991149902344,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1104.8060302734375
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        -0.25882023572921753,
        0.0
      ],
      "plane_d": -3493.421875,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1105.4346923828125
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        0.7071075439453125
      ],
      "plane_d": -892.6690673828125,
      "bbox_min": [
        -2525.413818359375,
        -4073.922607421875,
        1111.623779296875
      ],
      "bbox_max": [
        -2522.5478515625,
        -4069.592529296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882023572921753,
        0.9659255146980286,
        0.0
      ],
      "plane_d": 3285.10791015625,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1106.4822998046875
      ],
      "bbox_max": [
        -2524.681884765625,
        -4073.922607421875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        0.7071075439453125
      ],
      "plane_d": -892.6690673828125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1108.5775146484375
      ],
      "bbox_max": [
        -2527.5478515625,
        -4078.252685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        -0.7071075439453125
      ],
      "plane_d": 680.8203125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1108.5775146484375
      ],
      "bbox_max": [
        -2529.681884765625,
        -4082.5830078125,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882023572921753,
        0.9659255146980286,
        0.0
      ],
      "plane_d": 3292.178955078125,
      "bbox_min": [
        -2532.5478515625,
        -4086.9130859375,
        1108.5775146484375
      ],
      "bbox_max": [
        -2531.181884765625,
        -4086.546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123719215393066,
        0.3535570800304413,
        -0.7071053385734558
      ],
      "plane_d": 680.8380126953125,
      "bbox_min": [
        -2527.5478515625,
        -4078.252685546875,
        1111.623779296875
      ],
      "bbox_max": [
        -2524.681884765625,
        -4073.922607421875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123722195625305,
        0.35355231165885925,
        -0.7071075439453125
      ],
      "plane_d": 680.8203125,
      "bbox_min": [
        -2522.5478515625,
        -4069.592529296875,
        1111.623779296875
      ],
      "bbox_max": [
        -2519.681884765625,
        -4065.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9982019066810608,
        0.05994124338030815,
        0.0
      ],
      "plane_d": -2291.517333984375,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1103.5489501953125
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5509783625602722,
        -0.8345195651054382,
        0.0
      ],
      "plane_d": -1986.1607666015625,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1103.5489501953125
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999895691871643,
        -0.866025984287262,
        -0.0
      ],
      "plane_d": -4781.64404296875,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1103.758544921875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22360321879386902,
        -0.3872932195663452,
        0.8944302797317505
      ],
      "plane_d": -3133.103759765625,
      "bbox_min": [
        -2539.16748046875,
        -4055.87841796875,
        1112.123779296875
      ],
      "bbox_max": [
        -2537.368408203125,
        -4054.262451171875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9982051849365234,
        -0.05988685414195061,
        0.0
      ],
      "plane_d": 2301.138427734375,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1108.5775146484375
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5510034561157227,
        0.8345029950141907,
        0.0
      ],
      "plane_d": 1995.4210205078125,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1108.5775146484375
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.866025984287262,
        -0.0
      ],
      "plane_d": 4804.64404296875,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1108.5775146484375
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22360868752002716,
        0.3873026967048645,
        0.8944248557090759
      ],
      "plane_d": 1154.0137939453125,
      "bbox_min": [
        -2551.600341796875,
        -4076.9130859375,
        1112.123779296875
      ],
      "bbox_max": [
        -2549.80126953125,
        -4075.296875,
        1112.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: jct01",
      "entity_class": "CGameArea",
      "piece_name": "jct01",
      "offset": 54,
      "centroid": [
        -2535.6392822265625,
        -4043.8383178710938,
        1108.5619201660156
      ],
      "bbox_min": [
        -2542.147216796875,
        -4060.82666015625,
        1100.0
      ],
      "bbox_max": [
        -2527.424560546875,
        -4028.199951171875,
        1115.623779296875
      ],
      "dimensions_source": {
        "span_x": 14.72265625,
        "span_y": 32.626708984375,
        "height_z": 15.623779296875,
        "door_width": 32.626708984375,
        "door_depth": 14.72265625,
        "leaf_depth": 14.72265625,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.8651,
          -0.5015,
          0.0
        ]
      },
      "vertices": [
        [
          -2534.8115234375,
          -4028.199951171875,
          1115.623779296875
        ],
        [
          -2534.8115234375,
          -4028.199951171875,
          1104.6239013671875
        ],
        [
          -2538.173828125,
          -4034.0,
          1104.6239013671875
        ],
        [
          -2538.173828125,
          -4034.0,
          1115.623779296875
        ],
        [
          -2542.147216796875,
          -4052.32666015625,
          1100.0
        ],
        [
          -2527.424560546875,
          -4060.82666015625,
          1100.0
        ],
        [
          -2527.424560546875,
          -4060.82666015625,
          1114.0
        ],
        [
          -2542.147216796875,
          -4052.32666015625,
          1114.0
        ]
      ],
      "plane_distance": 172.728,
      "authentic_texture": "elevjct2"
    }
  ],
  "tutorial_messages": []
}